import {FETCH} from "../fetch";
import {userRoutes} from "../routes/user";

export class User {

}
